import {
    ASSIGN_LEAD,
    ASSIGN_LEAD_SUCCESS,
    ASSIGN_LEAD_FAILURE,
    ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT,
    ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT_SUCCESS,
    ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT_FAILURE,
} from '../constants/assign_lead.constants';

export const assignLeadRequest = (userId, leadId) => ({ type: ASSIGN_LEAD, userId, leadId });
export const assignLeadSuccess = (payload) => ({ type: ASSIGN_LEAD_SUCCESS, payload });
export const assignLeadFailure = (error) => ({ type: ASSIGN_LEAD_FAILURE, error });

export const assignLeadDeliveryRequestedAgentRequest = (userId, leadId) => ({ type: ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT, userId, leadId });
export const assignLeadDeliveryRequestedAgentSuccess = (payload) => ({ type: ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT_SUCCESS, payload });
export const assignLeadDeliveryRequestedAgentFailure = (error) => ({ type: ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/actions/assign_lead.actions.js